import { trace, SpanKind, SpanStatusCode } from '@opentelemetry/api';
let enabled = false;
let heartbeatCount = 0;
export function setBrowserTelemetryEnabled(value) {
    enabled = value;
}
function record(transport, event, url, provider, duration) {
    if (!enabled)
        return;
    try {
        const span = trace.getTracer('nava-browser').startSpan(`${transport} ${event}`, {
            kind: SpanKind.CLIENT,
            attributes: {
                'nava.browser.transport': transport,
                'nava.browser.event': event,
                'http.url': url,
                ...(provider ? { 'nava.browser.provider': provider } : {}),
                ...(duration !== undefined ? { 'nava.browser.duration_ms': duration } : {}),
            },
        });
        if (['failure', 'rejected', 'abnormal'].includes(event))
            span.setStatus({ code: SpanStatusCode.ERROR });
        span.end();
    }
    catch {
        /* Diagnostics cannot change connection behavior. */
    }
}
/** SDK adapters call this once per logical connection; no media or SDK payloads accepted. */
export function startBrowserConnection(transport, destination) {
    const started = Date.now();
    let openedAt;
    let ended = false;
    let timer;
    const stopHeartbeat = () => {
        if (timer !== undefined) {
            clearInterval(timer);
            timer = undefined;
            heartbeatCount--;
        }
    };
    const emit = (event, duration) => record(transport, event, destination.url ?? '', destination.provider, duration);
    emit('attempt');
    return {
        opened() {
            if (ended || openedAt !== undefined)
                return;
            openedAt = Date.now();
            emit('open', openedAt - started);
            if (enabled && heartbeatCount < 128) {
                heartbeatCount++;
                timer = setInterval(() => emit('heartbeat'), 30000);
            }
        },
        failed() {
            if (!ended) {
                ended = true;
                stopHeartbeat();
                emit('failure');
            }
        },
        closed(abnormal = false) {
            if (ended)
                return;
            ended = true;
            stopHeartbeat();
            if (openedAt === undefined)
                emit('failure');
            else
                emit(abnormal ? 'abnormal' : 'close', Date.now() - openedAt);
        },
    };
}
export function installBrowserTransports(exportEndpoint) {
    if (typeof navigator.sendBeacon === 'function') {
        const original = navigator.sendBeacon.bind(navigator);
        navigator.sendBeacon = (url, data) => {
            const queued = original(url, data);
            try {
                const target = new URL(String(url), location.href);
                if (target.href !== exportEndpoint)
                    record('beacon', queued ? 'queued' : 'rejected', target.href);
            }
            catch {
                /* Invalid destination has already been handled by the browser. */
            }
            return queued;
        };
    }
    if (typeof WebSocket === 'function') {
        const Original = globalThis.WebSocket;
        globalThis.WebSocket = new Proxy(Original, {
            construct(target, args, newTarget) {
                const socket = Reflect.construct(target, args, newTarget);
                const connection = startBrowserConnection('websocket', { url: socket.url });
                socket.addEventListener('open', () => connection.opened(), { once: true });
                socket.addEventListener('error', () => connection.failed(), { once: true });
                socket.addEventListener('close', (event) => connection.closed(!event.wasClean), {
                    once: true,
                });
                return socket;
            },
        });
    }
}
//# sourceMappingURL=transports.js.map